import { Link as InertiaLink } from "@inertiajs/react";

export function Link({ children, ...attrs }) {
  return (
    <InertiaLink
      className="text-gray-600 hover:text-black hover:underline aria-disabled:text-gray-400 aria-disabled:pointer-events-none"
      {...attrs}
    >
      {children}
    </InertiaLink>
  );
}
